import type { ProviderGetImage } from "@nuxt/image";

/**
 * @nuxt/image provider for the Norce media CDN.
 *
 * This provider makes NuxtImg the owner of the sizing params: pass a clean
 * absolute URL (existing query params are preserved) and real `width`/`sizes`
 * props, and every srcset candidate gets its own `w=`.
 */
export const getImage: ProviderGetImage = (src, { modifiers = {} } = {}) => {
	// Norce media URLs are always absolute; a relative src means the caller
	// forgot the CDN host. Pass it through untouched instead of throwing in
	// `new URL()` and taking the whole page render down.
	if (!/^https?:\/\//.test(src)) {
		return { url: src };
	}

	const url = new URL(src);

	if (modifiers.width) {
		url.searchParams.set("w", String(Math.round(modifiers.width)));
	}
	if (modifiers.format) {
		url.searchParams.set("format", modifiers.format);
	}

	return { url: url.href };
};
